import type { Difficulty } from '../sudoku';
import type { MistakeMode } from '../api/types';

export const STRIKE_LIMIT = 3;

export type GameStatus = 'playing' | 'solved' | 'failed';

/** Serializable slice used for undo/redo snapshots. */
export interface Snapshot {
  cells: number[];
  notes: number[][];
}

export interface GameState {
  key: string; // 'daily:<date>' | 'level:<uuid>'
  kind: 'daily' | 'level';
  difficulty: Difficulty;
  givens: number[]; // 81, immutable starting clues (0 = empty)
  cells: number[]; // 81 current values (0 = empty)
  notes: number[][]; // 81 candidate lists (sorted, unique)
  selected: number | null;
  notesMode: boolean;
  elapsedMs: number;
  running: boolean;
  status: GameStatus;
  mistakes: number;
  hintsUsed: number;
  past: Snapshot[];
  future: Snapshot[];
}

/** Settings that influence how an input mutates the board. Threaded through the
 *  action so the reducer stays decoupled from the settings context. */
export interface InputConfig {
  autoRemoveNotes: boolean;
  mistakeMode: MistakeMode;
}

export type Action =
  | { type: 'select'; index: number }
  | { type: 'move'; dir: 'up' | 'down' | 'left' | 'right' }
  | { type: 'input'; value: number; config: InputConfig }
  | { type: 'erase' }
  | { type: 'toggleNotesMode' }
  | { type: 'autoNotes' }
  | { type: 'undo' }
  | { type: 'redo' }
  | { type: 'tick'; ms: number }
  | { type: 'setRunning'; running: boolean }
  | { type: 'useHint' }
  | { type: 'placeHint'; index: number; value: number; config: InputConfig };
